import { Button, DatePicker, Divider, Menu, Spin, Table } from 'antd';
import { ColumnsType, TableRowSelection } from 'antd/lib/table/interface';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import returnDisposalService from '../../Return/Service/returnDisposal';
import { useActions } from '@root/core/hooks/useActions';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useDebounce from '@root/core/hooks/useDebounce';
import SearchBox from '@modules/Sellers/Inquiry/components/Search';
import DropdownButton from '@modules/Sellers/Inquiry/components/DropdownButton';

interface DataType {
  key: React.Key;
  No: number;
  sellerName: string;
  productName: string;
  SKU: string;
  quantity: number;
  processType: string;
  status: string;
  updateDate: string;
  returnType: string;
}
interface labelSelect {
  key: string;
  label: string;
}

// handle get List returns

const ReturnDeliveryList = () => {
  const [dateValue, setDateValue] = useState<[string, string]>();
  const filterDateFrom: string = (dateValue && dateValue[0]) || '';
  const filterDateTo: string = (dateValue && dateValue[1]) || '';
  const [searchBy, setSearchBy] = useState({
    value: '',
    label: 'Select'
  });
  const [deliveryStatus, setDeliveryStatus] = useState({
    value: '',
    label: 'Select'
  });
  const [inspectionStatus, setInspectionStatus] = useState({
    value: '',
    label: 'Select'
  });
  const [filterBy, setFilterBy] = useState<string>();
  const [filter, setFilter] = useState<string>();

  const [valueSearch, setValueSearch] = useState<string>('');

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [sort, setSort] = useState(true);
  const debounce = useDebounce(valueSearch, 1000);

  const history = useHistory();
  const { handleReturnDisposalListWithPagination } = useActions();

  const columns: ColumnsType<DataType> = [
    {
      title: 'NO',
      dataIndex: 'id'
    },
    {
      title: 'Seller Name',
      dataIndex: 'name'
    },
    {
      title: 'Product Name',
      dataIndex: 'productName'
    },
    {
      title: 'Order Number',
      dataIndex: 'orderNumber'
    },
    {
      title: 'SKU',
      dataIndex: 'sku'
    },
    // {
    //   title: 'Return / Disposal',
    //   dataIndex: 'processType'
    // },
    {
      title: 'Delivery Status',
      dataIndex: 'returnStatus'
    },
    {
      title: 'Inspection Status',
      dataIndex: 'status',
      render: (value: string) => {
        return {
          Request: 'Before Inspect',
          Inprogress: 'In Progress',
          Complete: 'Complete'
        }[value];
      }
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          Update Date
          {!sort ? (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(true);
                setCurrentPage(1);
              }}
            />
          ) : (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(false);
                setCurrentPage(1);
              }}
            />
          )}
        </div>
      ),
      dataIndex: 'updatedAt'
    }
  ];

  useEffect(() => {
    if (currentPage === 1) {
      handleReturnDisposalListWithPagination(
        currentPage,
        sort,
        filterDateFrom,
        filterDateTo,
        filterBy,
        searchBy.value,
        debounce,
        1,
        filter
      );
    } else {
      setCurrentPage(1);
    }
  }, [
    sort,
    filterDateFrom,
    filterDateTo,
    filterBy,
    searchBy,
    debounce,
    filter
  ]);
  const { data, loading } = useTypedSelector(
    (state) => state.returnDisposalReducer
  );
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection: TableRowSelection<DataType> = {
    selectedRowKeys,
    onChange: onSelectChange,
    preserveSelectedRowKeys: true
  };
  const idMap = selectedRowKeys.map((item: React.Key) => item);

  const arrId = {
    ids: idMap
  };
  const handleDownload = async () => {
    const isReturnProduct = 1;
    if (selectedRowKeys.length === 0) {
      const resp = await returnDisposalService.exportExcel({
        currentPage,
        sort,
        filterDateFrom,
        filterDateTo,
        filterBy,
        searchBy: searchBy.value,
        valueSearch,
        isReturnProduct,
        filter
      });
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Return_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([resp]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await returnDisposalService.postDownloadExcelId(
        arrId,
        1
      );
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Return_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY.MM.DD';

  const listLabel = [
    {
      id: 1,
      label: deliveryStatus.label,
      title: 'Delivery status',
      listMenu: (
        <Menu
          onClick={(e: any) =>
            setDeliveryStatus({
              value: e.key,
              label: e.domEvent.target.innerText
            })
          }
          items={[
            {
              label: 'Request',
              key: 'Request'
            },
            {
              label: 'In progress',
              key: 'Inprogress'
            },
            {
              label: 'Complete',
              key: 'Completed'
            }
          ]}
        />
      )
    },
    {
      id: 2,
      label: inspectionStatus.label,
      title: 'Inspection status',
      listMenu: (
        <Menu
          onClick={(e: any) =>
            setInspectionStatus({
              value: e.key,
              label: e.domEvent.target.innerText
            })
          }
          items={[
            {
              label: 'Before Inspect',
              key: 'Request'
            },
            {
              label: 'In Progress',
              key: 'Inprogress'
            },
            {
              label: 'Complete',
              key: 'Complete'
            }
          ]}
        />
      )
    },
    {
      id: 3,
      label: searchBy.label,
      listMenu: (
        <Menu
          onClick={(e: any) =>
            setSearchBy({ value: e.key, label: e.domEvent.target.innerText })
          }
          items={[
            {
              label: 'Product name',
              key: 'productName'
            },
            {
              label: 'SKU',
              key: 'sku'
            },
            {
              label: 'Warehouse name',
              key: 'warehouseName'
            }
          ]}
        />
      )
    }
  ];

  useEffect(() => {
    let filter = '';
    if (inspectionStatus.value !== '') {
      filter += `inspectionStatus:${inspectionStatus.value}`;
    }
    if (filter !== '') {
      filter += ',';
    }
    if (deliveryStatus.value !== '') {
      filter += `deliveryStatus:${deliveryStatus.value}`;
    }

    setFilter(filter);
  }, [inspectionStatus, deliveryStatus]);

  return (
    <Spin spinning={loading} className="loading-forgot">
      <>
        <div className="control">
          <RangePicker
            style={{ minWidth: '250px' }}
            onChange={(date: any, dateString: [string, string]) => {
              setDateValue(dateString);
            }}
            placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
            format={dateFormat}
          />
          {listLabel.map((item) => {
            return (
              <>
                <DropdownButton
                  key={item.id}
                  label={item.label}
                  title={item.title}
                  menu={item.listMenu}
                />
              </>
            );
          })}
          <SearchBox onChange={(e: any) => setValueSearch(e.target.value)} />
        </div>
        <br />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '15px 17px',
            background: 'white',
            alignItems: 'center'
          }}
        >
          <div>
            <span style={{ marginLeft: 8, marginRight: 8 }}>
              Total {data.count}
            </span>
            <Divider type="vertical" />
            <span style={{ marginLeft: 8 }}>
              Select {selectedRowKeys.length}
            </span>
          </div>

          <div>
            <Button className="downExcel" onClick={handleDownload}>
              Download Excel
            </Button>
          </div>
        </div>

        <Table
          className="warehouse-table"
          rowSelection={rowSelection}
          columns={columns}
          dataSource={data?.rowData}
          pagination={{
            pageSize: 10,
            total: data.count,
            current: currentPage,
            onChange: (currentPage) => {
              setCurrentPage(currentPage);
              handleReturnDisposalListWithPagination(
                currentPage,
                sort,
                filterDateFrom,
                filterDateTo,
                filterBy,
                searchBy.value,
                valueSearch,
                1
              );
            }
          }}
          onRow={(record) => {
            return {
              onClick: () => {
                history.push({
                  pathname: `/admin/returnDelivery/${record.key}?return_type=${record.returnType}`,
                  state: {
                    state: `${record.returnType}`,
                    status: `${record.status}`
                  }
                });
              }
            };
          }}
        />
      </>
    </Spin>
  );
};

export default ReturnDeliveryList;
